import { createFileRoute } from '@tanstack/react-router';
import { JourneysCampaignSetupHandoff } from '@/pages/workspaces/automations/[campaignId]/workflow/routing';

function JourneysCampaignsSetupSettingsRoute() {
  const { campaignId } = Route.useParams();
  return <JourneysCampaignSetupHandoff campaignId={campaignId} step="settings" />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/campaigns/$campaignId/setup/settings',
)({
  component: JourneysCampaignsSetupSettingsRoute,
});
